<style>
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans:wght@600&family=Roboto+Slab&display=swap');
</style>


<body>
    <div class="separator">
        <h1 class="header">Upcoming Events!</h1>
    </div>
    <div *ngIf="isOrg===true" class="separator">
        <button class="add-event-button" style="font-family: Noto Sans" (click)="newEvent()" mat-button>
            <mat-icon>add</mat-icon>
            Add Event
        </button>
    </div>

    <div class="sidenav">
        <div>
            <p class="item-header">Filter Events</p>
            <ul>
                <li *ngFor="let key of interestKeys">
                    <label class="checkbox" [htmlFor]="key">
                        <input type="checkbox" [id]="key" [name]="key" [value]="key" (change)="onCheckChange($event, key)" required="required">
                        <div>
                            <span class="checkbox-text">{{interestOptions[key]}}</span>
                            <img class="toggle-icon" src="assets/plus.svg" alt="">
                        </div>
                    </label>
                </li>
            </ul>
            <button mat-raised-button type="submit" value="submit" (click)="refreshEvents()">Apply</button>
        </div>
    </div>

    <app-events-list></app-events-list>
</body>